import { useMutation } from '@apollo/client';

import type {
  UpdateUserPermissionsMutation,
  UpdateUserPermissionsMutationVariables,
} from 'src/graphql/generated';
import { UDPATE_USER_PERMISSIONS_MUTATION } from 'src/graphql/gql_mutations';
import { HIRER_USER_QUERY, USER_LIST_QUERY } from 'src/graphql/gql_queries';

export const useUpdateEditedPermissions = () => {
  const [mutate, { data, loading, error }] = useMutation<
    UpdateUserPermissionsMutation,
    UpdateUserPermissionsMutationVariables
  >(UDPATE_USER_PERMISSIONS_MUTATION, {
    refetchQueries: [USER_LIST_QUERY, HIRER_USER_QUERY],
  });

  return { mutate, data, loading, error };
};
